var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"chapter-title"},[_vm._v(_vm._s(_vm.chapterInfo.title))]),_c('div',{staticClass:"chapter-content",domProps:{"innerHTML":_vm._s(_vm.chapterInfo.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }